import { ButtonSubmitController, Controllers } from "radium-omnibus";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BlueButton } from "../../../components/attributes/Button";
import FieldTextState from "../../../components/field/Field.TextState";
import Container from "../../../components/layouts/Container";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  CONSTANT_LANGUAGE,
  TEXT_CONTACT_US,
  TEXT_EMAIL,
  TEXT_FULL_NAME,
  TEXT_MY_PROFILE,
  TEXT_PHONE_NUMBER,
  TEXT_SAVE,
} from "../../../utils/useConstants";
import {
  STYLE_ADDRESS_BG,
  STYLE_BG_INPUT_DISABLE_PHONENUMBER,
  STYLE_BOTTOM_BAR,
  STYLE_BUTTON_BLUE,
  STYLE_BUTTON_BLUE_DISABLED,
  STYLE_FLEX_INPUT_FOOTER,
  STYLE_HEIGHT_BAR,
  STYLE_INPUT_FOOTER,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_NO_MB,
  STYLE_PARENT_PROFILE,
  STYLE_SCREEN_FULL,
} from "../../../utils/useStyle";
import api from "../../../utils/useApi";
import { ICON_VERIFY } from "../../../utils/useIcons";
import { useIsMobile } from "../../../utils/useIsMobile";
import ProgramGoBack from "../../task/render/Program.GoBack";
import FieldPhoneCountry from "../../../utils/PhoneNumber/usePhoneNumber";
import { initAuth } from "../../../redux/auth.reducer";
import { FunctionCheckEmail } from "../../login/function/Login.UpdateProfile";

const ProfileLogin = ({ title }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = React.useContext(ContextLanguage);
  const [form, setForm] = React.useState({});
  const [email, setEmail] = React.useState("");
  const [name, setName] = React.useState("");
  const [emailLocal, setEmailLocal] = React.useState("");
  const [nameLocal, setNameLocal] = React.useState("");
  const { user } = useSelector((state) => state.auth);
  const IsMobile = useIsMobile();
  // const [isEdit, setIsEdit] = React.useState(false);

  const isEdit = nameLocal !== name || emailLocal !== email;

  React.useEffect(() => {
    if (user) {
      setEmail(user.email);
      setName(user.full_name);
      setEmailLocal(user.email);
      setNameLocal(user.full_name);
    } else {
      return;
    }
  }, [user]);

  // console.log(
  //   "X : ",
  //   FieldPhoneCountry?.find((i) => {
  //     return user?.phone_code === i?.value;
  //   })?.image || "/icons/thai.svg"
  // );

  return (
    <div className={STYLE_SCREEN_FULL} id="scroll_login">
      <Container>
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
          <div
            onClick={() => {
              // setTab(STATE_CONSTANTS_PROFILE?.CURRENT);
            }}
            className={STYLE_ADDRESS_BG}
          >
            <ProgramGoBack
              onClick={(e) => {
                e.stopPropagation();
                navigate("/");
              }}
              title={title ? title : TEXT_MY_PROFILE[language]}
            />
            {/* <img src="/images/logo.png" className="h-10 mx-auto my-4" /> */}
            <div className={STYLE_PARENT_PROFILE}>
              <Controllers
                loadData={user}
                showError={false}
                fields={[
                  {
                    name: "full_name",
                    type: "customs",
                    classNameCore:
                      " pb-3 md:pb-[13px] pt-4 md:pt-6 text-laudry-gray-200 ",
                    fieldCustoms: ({ value, setValue }) => {
                      return (
                        <FieldTextState
                          label={TEXT_FULL_NAME[language]}
                          setValue={setName}
                          value={name}
                          icon={
                            <svg
                              width="21"
                              height="20"
                              viewBox="0 0 21 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.4871 12.7891C7.2641 12.7891 4.51172 13.2764 4.51172 15.228C4.51172 17.1795 7.24664 17.6843 10.4871 17.6843C13.7101 17.6843 16.4617 17.1962 16.4617 15.2454C16.4617 13.2946 13.7276 12.7891 10.4871 12.7891Z"
                                stroke="CurrentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.4874 10.0052C12.6025 10.0052 14.3168 8.29015 14.3168 6.17507C14.3168 4.05999 12.6025 2.3457 10.4874 2.3457C8.37233 2.3457 6.65725 4.05999 6.65725 6.17507C6.65011 8.283 8.35328 9.99808 10.4604 10.0052H10.4874Z"
                                stroke="CurrentColor"
                                strokeWidth="1.42857"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          }
                        />
                      );
                    },
                  },
                  {
                    name: "email",
                    type: "customs",
                    classNameCore: " pb-3 md:pb-[13px] laudry-gray-200 ",
                    fieldCustoms: ({ value, setValue }) => {
                      return (
                        <FieldTextState
                          label={TEXT_EMAIL[language]}
                          setValue={setEmail}
                          value={email}
                          icon={
                            <svg
                              width="21"
                              height="20"
                              viewBox="0 0 21 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18 5.83366C18 4.91318 17.2538 4.16699 16.3333 4.16699H4.66667C3.74619 4.16699 3 4.91318 3 5.83366M18 5.83366V14.167C18 15.0875 17.2538 15.8337 16.3333 15.8337H4.66667C3.74619 15.8337 3 15.0875 3 14.167V5.83366M18 5.83366L10.5 10.8337L3 5.83366"
                                stroke="CurrentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          }
                        />
                      );
                    },
                  },
                  {
                    name: "phone_number",
                    type: "customs",
                    fieldCustoms: ({ value, setValue, reference }) => {
                      return (
                        <div
                          className={`${STYLE_BG_INPUT_DISABLE_PHONENUMBER(
                            language
                          )} mb-6`}
                        >
                          <div className={STYLE_FLEX_INPUT_FOOTER}>
                            <img
                              src={
                                FieldPhoneCountry?.find((i) => {
                                  return user?.phone_code === i?.value;
                                })?.image || "/icons/thai.svg"
                              }
                              className="w-8 rounded-[3px]"
                            />
                            <div
                              className={` text-laudry-gray-200 my-auto  ${
                                language === CONSTANT_LANGUAGE.TH
                                  ? " font-Poppins text-base "
                                  : " font-Poppins text-base "
                              }  `}
                            >
                              {value?.slice(0, 3)}
                            </div>
                            <div className="border-r border-r-laudry-stroke h-full mr-8"></div>
                          </div>
                          <input
                            ref={reference}
                            className={`${STYLE_INPUT_FOOTER} font-Poppins text-base bg-transparent  text-laudry-gray-200 -ml-4 md:-ml-6  cursor-default `}
                            placeholder={TEXT_PHONE_NUMBER[language]}
                            value={value?.slice(3)}
                            onChange={(e) => {
                              if (value) {
                                return;
                              } else {
                                setValue(e.target.value);
                              }
                            }}
                            onClick={() => {
                              //blur
                              reference.current.blur();
                            }}
                            // disabled
                          />
                          <ICON_VERIFY className=" w-4 " />
                        </div>
                      );
                    },
                  },
                  // {
                  //   name: "phone_number",
                  //   type: "text",
                  //   placeholder: TEXT_PHONE_NUMBER[language],
                  //   classNameInput: `${STYLE_INPUT_FOOTER} ${
                  //     language === CONSTANT_LANGUAGE.TH
                  //       ? "font-NotoSansThai"
                  //       : "font-Poppins"
                  //   }`,
                  //   isEdit: false,
                  //   classNameCore: STYLE_INPUT_PHONENUMBER,
                  // },
                  {
                    type: "none",
                    classNameCore: "mx-auto flex justify-center",
                    render: () => {
                      return (
                        <div
                          onClick={() => navigate("/ContactUs")}
                          className={`${STYLE_LINK_BLUE} text-center w-28 flex justify-center mx-auto`}
                        >
                          {IsMobile ? (
                            <div className="mx-auto w-fit">
                              {TEXT_CONTACT_US[language]}
                            </div>
                          ) : (
                            <div className="mx-auto w-fit">
                              {TEXT_CONTACT_US[language]}
                            </div>
                          )}
                        </div>
                      );
                    },
                  },
                ]}
                onSubmit={(form) => {
                  setForm(form);
                }}
                classNameSubmit="hidden"
              />
            </div>
          </div>
        </div>
        {/* <div
          onClick={() => {
            navigate("/ContactUs");
          }}
          className="linkblue w-fit mx-auto"
        >
          Contact Us
        </div> */}
      </Container>
      <div className="w-full bg-white">
        <div
          className={`${STYLE_BOTTOM_BAR} ${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_HEIGHT_BAR} px-4`}
        >
          <BlueButton
            className={
              isEdit > 0
                ? STYLE_BUTTON_BLUE(language)
                : STYLE_BUTTON_BLUE_DISABLED(language)
            }
            title={TEXT_SAVE[language]}
            onClick={async () => {
              if (isEdit) {
                const emailAlert = FunctionCheckEmail(
                  email,
                  "Please enter a valid email"
                );
                if (emailAlert) {
                  alert(emailAlert);
                  return;
                }
                await api.put(`/profiles/${user?._id}`, {
                  email: email,
                  full_name: name,
                });
                setNameLocal(name);
                setEmailLocal(email);
                dispatch(initAuth());

                // window.location.reload();
              } else {
                return;
              }
            }}
          />
        </div>
      </div>

      {/* <ButtonSubmitController
        classNameSubmit="w-full"
        labelSubmit={
          <div
            className={`${STYLE_BOTTOM_BAR} ${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_HEIGHT_BAR} px-4`}
          >
            <BlueButton
              className={
                isEdit > 0
                  ? STYLE_BUTTON_BLUE(language)
                  : STYLE_BUTTON_BLUE_DISABLED(language)
              }
              title={TEXT_SAVE[language]}
              onClick={async () => {
                if (isEdit) {
                  const emailAlert = FunctionCheckEmail(
                    email,
                    "Please enter a valid email"
                  );
                  if (emailAlert) {
                    alert(emailAlert);
                    return;
                  }
                  await api.put(`/profiles/${user?._id}`, {
                    email: email,
                    full_name: name,
                  });
                  setNameLocal(name);
                  setEmailLocal(email);
                  dispatch(initAuth());

                  // window.location.reload();
                } else {
                  return;
                }
              }}
            />
          </div>
        }
      /> */}
    </div>
  );
};

export default ProfileLogin;
